"use strict";
var accordionItems = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < accordionItems.length; i++) {
    accordionItems[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = "";
        }
        else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}
